class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    
    // Add hover functionality for mega menus
    if (this.mainDetailsToggle.classList.contains('mega-menu')) {
      this.setupHoverEvents();
    }
  }

  setupHoverEvents() {
    const summary = this.mainDetailsToggle.querySelector('summary');
    const content = this.mainDetailsToggle.querySelector('.mega-menu__content');
    const header = document.querySelector('.header');
    
    // Only apply hover functionality on desktop (min-width: 990px)
    const isDesktop = window.matchMedia('(min-width: 990px)').matches;
    
    if (!isDesktop) {
      // On mobile, allow normal click behavior
      return;
    }
    
    let isMenuOpen = false;
    let closeTimeout;
    
    // Mouse enter on summary - show menu instantly
    const showMenu = () => {
      if (closeTimeout) {
        clearTimeout(closeTimeout);
        closeTimeout = null;
      }
      
      if (!isMenuOpen) {
        this.mainDetailsToggle.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
        this.onToggle();
        isMenuOpen = true;
      }
    };
    
    // Mouse leave - hide menu with small delay to allow moving to content
    const hideMenu = () => {
      closeTimeout = setTimeout(() => {
        this.mainDetailsToggle.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
        this.onToggle();
        isMenuOpen = false;
      }, 100); // Small delay to allow moving to content area
    };
    
    // Mouse enter on content - keep menu open
    const keepMenuOpen = () => {
      if (closeTimeout) {
        clearTimeout(closeTimeout);
        closeTimeout = null;
      }
    };
    
    // Mouse leave content - hide menu
    const hideMenuFromContent = () => {
      closeTimeout = setTimeout(() => {
        this.mainDetailsToggle.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
        this.onToggle();
        isMenuOpen = false;
      }, 100);
    };
    
    // Add event listeners to summary
    this.mainDetailsToggle.addEventListener('mouseenter', showMenu);
    this.mainDetailsToggle.addEventListener('mouseleave', hideMenu);
    
    // Add event listeners to content area
    if (content) {
      content.addEventListener('mouseenter', keepMenuOpen);
      content.addEventListener('mouseleave', hideMenuFromContent);
    }
    
    // Add event listeners to header to keep menu open when hovering anywhere in header
    if (header) {
      header.addEventListener('mouseenter', () => {
        if (isMenuOpen && closeTimeout) {
          clearTimeout(closeTimeout);
          closeTimeout = null;
        }
      });
      
      header.addEventListener('mouseleave', () => {
        if (isMenuOpen) {
          closeTimeout = setTimeout(() => {
            this.mainDetailsToggle.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
            this.onToggle();
            isMenuOpen = false;
          }, 100);
        }
      });
    }
    
    // Prevent click from toggling the menu (since we want hover only)
    summary.addEventListener('click', (e) => {
      e.preventDefault();
    });
    
    // Listen for window resize to handle responsive behavior
    window.addEventListener('resize', () => {
      const isDesktopNow = window.matchMedia('(min-width: 990px)').matches;
      if (!isDesktopNow) {
        // Remove hover event listeners on mobile
        this.mainDetailsToggle.removeEventListener('mouseenter', showMenu);
        this.mainDetailsToggle.removeEventListener('mouseleave', hideMenu);
        if (content) {
          content.removeEventListener('mouseenter', keepMenuOpen);
          content.removeEventListener('mouseleave', hideMenuFromContent);
        }
        if (header) {
          header.removeEventListener('mouseenter', () => {});
          header.removeEventListener('mouseleave', () => {});
        }
      }
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
